import React from 'react';
import styled, { css } from 'styled-components';
import { colors, weights } from '~/styles';
import { BulkActionOutcomeIcon } from '.';
import { Table } from '../table';

const Box = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  flex: ${({ size = 1 }) => size};
  &:not(:first-child) {
    border-left: 1px solid ${colors.grey10};
  }
  ${({ corner }) =>
    corner &&
    css`
      &:after {
        content: '';
        position: absolute;
        top: 0;
        right: 0;
        border-style: solid;
        border-color: transparent ${corner} transparent transparent;
        border-width: 0 0.75rem 0.75rem 0;
      }
    `}
`;

const Boxes = styled.div`
  display: flex;
  border: 1px solid ${colors.grey10};
  margin: auto 0 0 0rem;
  height: 3.5rem;
`;

const Value = styled.div`
  font-size: 1rem;
  font-weight: ${weights.bold};
  display: flex;
  justify-content: center;
  flex-direction: column;
  &:not(:first-child) {
    margin-top: 0.625rem;
  }
`;

const Label = styled.small`
  display: block;
  font-size: 0.75rem;
`;

export default function BulkActionSummary({ summary, rows, renderRow }) {
  return (
    <>
      <div style={{ marginBottom: '1rem' }}>
        <Boxes>
          <Box corner={colors.success}>
            <Value>{summary.succeeded}</Value>
            <Label>Succeeded</Label>
          </Box>
          <Box corner={colors.warning}>
            <Value>{summary.failed}</Value>
            <Label>Failed</Label>
          </Box>
          <Box corner={colors.grey40}>
            <Value>{summary.skipped}</Value>
            <Label>Skipped</Label>
          </Box>
        </Boxes>
      </div>

      {rows && (
        <Table small style={{ maxHeight: '50vh', overflowY: 'auto' }}>
          <Table.Header>
            <Table.Column>Details</Table.Column>
            <Table.Column width="6rem" align="center">
              Outcome
            </Table.Column>
          </Table.Header>

          <Table.Body>
            {rows.map((row) => {
              return (
                <Table.Row key={row.id}>
                  <Table.Cell>{renderRow(row)}</Table.Cell>
                  <Table.Cell>
                    <BulkActionOutcomeIcon outcome={row.outcome} message={row.message} />
                  </Table.Cell>
                </Table.Row>
              );
            })}
          </Table.Body>
        </Table>
      )}
    </>
  );
}
